import { render, staticRenderFns } from "./UpdatePwd.vue?vue&type=template&id=23b1970b&scoped=true"
import script from "./UpdatePwd.vue?vue&type=script&lang=js"
export * from "./UpdatePwd.vue?vue&type=script&lang=js"
import style0 from "./UpdatePwd.vue?vue&type=style&index=0&id=23b1970b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23b1970b",
  null
  
)

export default component.exports